import axios from 'axios';

export const api = axios.create({
    baseURL: "https://deck-maker-api.pages.dev/",
});
//comentário